/*eslint-disable */

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Animated } from "react-animated-css";
import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import AddPhysicianmodal from './addphysician';
import NewBrightreePhysician from './newbrightreephysician';
import AddEditPhysician from './newPhysician';

export function Physician() {
    const { user } = useSelector((state) => state.auth);
    //#region  add person
    const [showModalAddPhysician, setShowAddPhysician] = useState(false);
    const [syncPhysicianData, setSyncPhysicianData] = useState({ npi: null, firstName: null, lastName: null });


    const handleCloseAdd = () => {
        setShowAddPhysician(false);
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
    };
    
    const handleShowAddPhysician = () => {
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
        setShowAddPhysician(true);
    };

    const handleSavePhysician = (result) => {
        // Refresh the physician list after adding
        GetPhysicianList();
        setShowAddPhysician(false);
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
    };

    // Removed handleShowAddBrightreePhysician - not currently used


    //#endregion

    //#region physician list
    const [physician, setPhysician] = useState(null);
    const [physicianListUI, setPhysicianListUI] = useState([]);
    const [selectedPhysicians, setSelectedPhysicians] = useState([]);
    const [physicianListData, setPhysicianListData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [duplicatePhysician, setDuplicatePhysician] = useState(null);
    const [selectedReplacementPhysician, setSelectedReplacementPhysician] = useState(null);
    const [replacementFilter, setReplacementFilter] = useState('');
    //#endregion

    //#region sorting functions
    const sortData = (data, config) => {
        if (!config.key) return data;
        
        const sorted = [...data].sort((a, b) => {
            let aValue, bValue;
            
            if (config.key === 'name') {
                aValue = (Common.replaceNullWithString(a.lastName) + " " + Common.replaceNullWithString(a.firstName)).toLowerCase();
                bValue = (Common.replaceNullWithString(b.lastName) + " " + Common.replaceNullWithString(b.firstName)).toLowerCase();
            } else if (config.key === 'npi') {
                aValue = Common.replaceNullWithString(a.npi) || '';
                bValue = Common.replaceNullWithString(b.npi) || '';
            } else {
                return 0;
            }
            
            if (aValue < bValue) {
                return config.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return config.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        
        return sorted;
    }

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    }
    //#endregion

    useEffect(() => {
        GetPhysicianList();
    }, []);

    // Memoize sorted data to avoid unnecessary recalculations
    const sortedPhysicianData = useMemo(() => {
        if (physicianListData.length === 0) return [];
        return sortData(physicianListData, sortConfig);
    }, [physicianListData, sortConfig]);

    // Memoize selected physician IDs set for faster lookups
    const selectedPhysicianIds = useMemo(() => {
        return new Set(selectedPhysicians.map(p => p.physicianId));
    }, [selectedPhysicians]);

    // Recreate rows when sorted data or selections change
    useEffect(() => {
        if (sortedPhysicianData.length > 0) {
            setPhysicianList(sortedPhysicianData);
        }
    }, [sortedPhysicianData, selectedPhysicianIds]);

    
    




    //#region loop to  print the physician firm list

    const GetPhysicianList = () => {
        setIsLoading(true);
        Api.getRequest(Api.URI_GetAllPhysician).then((res) => {

            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    if (res.data.result.length > 0) {
                        setPhysicianListData(res.data.result);
                    } else {
                        setPhysicianListData([]);
                        setPhysicianList([]);
                    }
                } else {
                    setPhysicianListData([]);
                    setPhysicianList([]);
                }
            } else {
                setPhysicianListData([]);
                setPhysicianList([]);
            }

            Common.LoadDataTable("physicianList");
            setIsLoading(false);
        }).catch((ex) => {
            setPhysicianListData([]);
            setPhysicianList([]);
            setIsLoading(false);
        });
    }

    // Memoized handler for checkbox changes
    const handleCheckboxChange = useCallback((physician, isChecked) => {
        if (isChecked) {
            setSelectedPhysicians(prev => [...prev, physician]);
        } else {
            setSelectedPhysicians(prev => prev.filter(p => p.physicianId !== physician.physicianId));
        }
    }, []);

    const setPhysicianList = (list) => {
        let rows = [];
        try {
            for (var i = 0; i < list.length; i++) {
                const obj = list[i];
                const isSelected = selectedPhysicianIds.has(obj.physicianId);
                rows.push(<tr key={obj.physicianId || i.toString()}>
                    <td>
                        <input 
                            type="checkbox" 
                            value={obj.physicianId}
                            checked={isSelected}
                            onChange={(e) => handleCheckboxChange(obj, e.target.checked)}
                        />
                    </td>
                    <td>{Common.replaceNullWithString(obj.lastName) + " " + Common.replaceNullWithString(obj.firstName)}</td>
                    <td>{Common.replaceNullWithString(obj.title) ? obj.title : "N/A"}</td>
                    <td>{Common.replaceNullWithString(obj.address.phone1) != '' ? obj.address.phone1 : 'N/A'}</td>
                    <td>{Common.replaceNullWithString(obj.address.email) != '' ? obj.address.email : 'N/A'}</td>
                    <td>{Common.replaceNullWithString(obj.npi) != '' ? obj.npi : 'N/A'} </td>
                    <td align="center">
                        <div className="text-center">

                            <DropdownButton
                                drop={"down"}
                                size="xs"
                                variant="primary"
                                title={'Actions'}
                                id={`dropdown-button-drop-actions`}
                                key={'down'}>

                                {/* <Dropdown.Item eventKey={"1" + i.toString()} onClick={() => handleShowAdd(obj)}>Edit</Dropdown.Item> */}
                                <Dropdown.Item eventKey={"4" + i.toString()} onClick={() => HandleSetAsDuplicate(obj)}>Set as Duplicate</Dropdown.Item>
                                <Dropdown.Item eventKey={"3" + i.toString()} onClick={() => HandleSyncWithBrightree(obj)}>Sync With Brightree</Dropdown.Item>
                                <Dropdown.Item eventKey={"2" + i.toString()} onClick={() => ConfirmDeletePhysician(obj.physicianId)}>Delete</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </td>
                </tr>);
            }
            setPhysicianListUI(rows);
        } catch (error) {
        }
    }

    //#endregion

    //#region Delete Physician 

    const ConfirmDeletePhysician = (id) => {

        Common.showConfirmation("Are you sure! You want to delete this physician.", "Delete Physician", DeletePhysician, null, id)

    }

    const DeletePhysician = (id) => {
        Api.postRequest(Api.URI_DeletePhysician+"?physicianID="+id).then((res) => {
            
            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    Common.showSuccessAlertAutoClose("Physician deleted successfully", "success", "Success!", 3000);
                    GetPhysicianList();
                } 
                else {
                    Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                }
            }
            else {
                Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
        });
    }

    //#endregion

    //#region Sync Physician 

    const HandleSyncWithBrightree = (physicianObj) => {
        // Prefer NPI over name if available
        const npi = Common.replaceNullWithString(physicianObj.npi);
        const firstName = Common.replaceNullWithString(physicianObj.firstName);
        const lastName = Common.replaceNullWithString(physicianObj.lastName);
        
        setSyncPhysicianData({
            npi: npi && npi.length === 10 ? npi : null,
            firstName: npi && npi.length === 10 ? null : firstName,
            lastName: npi && npi.length === 10 ? null : lastName
        });
        setShowAddPhysician(true);
    }

    const SyncPhysician = (id) => {
        Api.postRequest(Api.URI_SyncPhysician + "?physicianID=" + id).then((res) => {
            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    Common.showSuccessAlertAutoClose("Physician synced successfully", "success", "Success!", 3000);
                    GetPhysicianList();
                } 
                else {
                    Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                }
            }
            else {
                Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
        });
    }

    const SelectAllPhysicians = () => {
        setSelectedPhysicians([...physicianListData]);
    }

    const HandleSelectAllToggle = (e) => {
        if (e.target.checked) {
            // Select all loaded physicians
            setSelectedPhysicians([...physicianListData]);
        } else {
            // Deselect all
            setSelectedPhysicians([]);
        }
    }

    const IsAllSelected = () => {
        if (physicianListData.length === 0) return false;
        return physicianListData.every(physician => selectedPhysicians.some(p => p.physicianId === physician.physicianId));
    }

    const SelectVisiblePhysicians = () => {
        // Get all visible rows from the table
        const table = document.getElementById("physicianList");
        if (!table) return;
        
        const visibleIds = [];
        const rows = table.querySelectorAll('tbody tr');
        rows.forEach((row) => {
            const checkbox = row.querySelector('input[type="checkbox"]');
            if (checkbox) {
                visibleIds.push(parseInt(checkbox.value));
            }
        });
        
        // Find the full physician objects for the visible IDs
        const visiblePhysicians = physicianListData.filter(physician => 
            visibleIds.includes(physician.physicianId)
        );
        
        setSelectedPhysicians(visiblePhysicians);
    }

    const SyncSelectedPhysicians = () => {
        if (selectedPhysicians.length === 0) {
            Common.showSuccessAlert("Please select at least one physician to sync", "warning", "No Selection!", 3000);
            return;
        }

        const physicianIds = selectedPhysicians.map(p => p.physicianId).join(',');
        Api.postRequest(Api.URI_SyncPhysicians + "?physicianIDs=" + physicianIds).then((res) => {
            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    Common.showSuccessAlertAutoClose("Physicians synced successfully", "success", "Success!", 3000);
                    setSelectedPhysicians([]);
                    GetPhysicianList();
                } 
                else {
                    Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                }
            }
            else {
                Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
        });
    }

    //#endregion

    //#region Set as Duplicate

    const HandleSetAsDuplicate = (physicianObj) => {
        setDuplicatePhysician(physicianObj);
        setSelectedReplacementPhysician(null);
        setShowDuplicateModal(true);
    }

    const HandleCloseDuplicateModal = () => {
        setShowDuplicateModal(false);
        setDuplicatePhysician(null);
        setSelectedReplacementPhysician(null);
        setReplacementFilter('');
    }

    const HandleConfirmDuplicate = () => {
        if (!selectedReplacementPhysician) {
            Common.showSuccessAlert("Please select a replacement physician", "warning", "No Selection!", 3000);
            return;
        }

        const confirmMessage = `Are you sure you want to replace all references of "${Common.replaceNullWithString(duplicatePhysician.lastName) + " " + Common.replaceNullWithString(duplicatePhysician.firstName)}" with "${Common.replaceNullWithString(selectedReplacementPhysician.lastName) + " " + Common.replaceNullWithString(selectedReplacementPhysician.firstName)}"? This will update all records that reference the current physician.`;
        
        Common.showConfirmation(
            confirmMessage, 
            "Replace Physician References", 
            () => {
                Api.postRequest(Api.URI_ReplacePhysicianReferences + "?duplicatePhysicianID=" + duplicatePhysician.physicianId + "&replacementPhysicianID=" + selectedReplacementPhysician.physicianId).then((res) => {
                    if (res.data.statusCode == 200) {
                        if (res.data.result != null) {
                            Common.showSuccessAlertAutoClose("All references have been updated successfully", "success", "Success!", 3000);
                            HandleCloseDuplicateModal();
                            GetPhysicianList();
                        } 
                        else {
                            Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                        }
                    }
                    else {
                        Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                    }
                }).catch((ex) => {
                    Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
                });
            }, 
            null, 
            null
        );
    }

    const GetReplacementPhysicians = () => {
        if (!duplicatePhysician) return [];
        let filtered = physicianListData.filter(p => p.physicianId !== duplicatePhysician.physicianId);
        
        // Apply filter if search text is provided
        if (replacementFilter && replacementFilter.trim() !== '') {
            const filterLower = replacementFilter.toLowerCase().trim();
            filtered = filtered.filter(physician => {
                const fullName = (Common.replaceNullWithString(physician.lastName) + " " + Common.replaceNullWithString(physician.firstName)).toLowerCase();
                const npi = Common.replaceNullWithString(physician.npi) || '';
                
                return fullName.includes(filterLower) || 
                       npi.toLowerCase().includes(filterLower);
            });
        }
        
        return filtered;
    }

    //#endregion

    const [ShowAdvancedSearch, showAdvanceSearchSectionState] = useState(ShowAdvancedSearch ? true : false);
    const showAdvanceSearchSection = () => {
        showAdvanceSearchSectionState(!ShowAdvancedSearch);
    };

    return (
        <>
            <Animated animationIn="fadeIn" animationInDuration={1000}>
            <Card className="example example-compact">
                <CardHeader title='Physician List' />
                <CardBody>
                <div className="alert border-primary bg-transparent text-primary fade show" role="alert">
                    <div className="d-flex align-items-center">
                        <div className="alert-icon">
                            {/* <i className="fas fa-info-circle mr-4 text-primary"></i> */}
                        </div>
                        <div className="flex-1">
                            {/* <span className="h5 m-0 fw-700">Use buttons to do more actions </span> */}
                        </div>
                        {!isLoading && (
                            <>
                                <Button variant="primary" className="mr-5" size="sm" onClick={handleShowAddPhysician}>Add New Physician</Button>
                                {/* <Button variant="primary" className="mr-5" size="sm" onClick={handleShowAddBrightreePhysician}>Add Brightree Physician</Button> */}
                                <DropdownButton
                                    variant="success"
                                    size="sm"
                                    title="Sync Physician(s)"
                                    id="sync-physician-dropdown"
                                    className="mr-5">
                                    <Dropdown.Item onClick={SelectAllPhysicians}>Select All Physicians</Dropdown.Item>
                                    <Dropdown.Item onClick={SelectVisiblePhysicians}>Select Visible Physicians</Dropdown.Item>
                                </DropdownButton>
                                {/* <Button variant="success" size="sm" onClick={SyncSelectedPhysicians}>Sync Selected</Button> */}
                            </>
                        )}
                    </div>
                </div>
                <table className="table table-striped table-hover table-sm table-bordered" id="physicianList">
                    <thead>
                        <tr>
                            <th width="50px">
                                <input 
                                    type="checkbox" 
                                    checked={IsAllSelected()}
                                    onChange={HandleSelectAllToggle}
                                />
                            </th>
                            <th 
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                onClick={() => handleSort('name')}
                            >
                                Name
                                {sortConfig.key === 'name' && (
                                    <span style={{ marginLeft: '5px' }}>
                                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                    </span>
                                )}
                            </th>
                            <th>Pro Designations</th>
                            <th>Telephone #</th>
                            <th>Email</th>
                            <th 
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                onClick={() => handleSort('npi')}
                            >
                                NPI #
                                {sortConfig.key === 'npi' && (
                                    <span style={{ marginLeft: '5px' }}>
                                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                    </span>
                                )}
                            </th>
                            <th width="130px">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {physicianListUI}
                    </tbody>
                </table>
                </CardBody>
            </Card>
                

            </Animated>

            {/* Add New Physician Modal */}
            <AddEditPhysician
                open={showModalAddPhysician}
                toggleModal={handleCloseAdd}
                onSaveAPI={handleSavePhysician}
                userID={user.userID}
                facilityId={null}
                npi={syncPhysicianData.npi}
                firstName={syncPhysicianData.firstName}
                lastName={syncPhysicianData.lastName}
            />

            {/* Duplicate Physician Modal */}
            <Modal
                show={showDuplicateModal}
                onHide={HandleCloseDuplicateModal}
                size="lg"
                centered
                scrollable
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Set as Duplicate - Select Replacement Physician</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {duplicatePhysician && (
                        <div className="mb-3">
                            <h6>Current Physician (all references will be replaced):</h6>
                            <p className="mb-0">
                                <strong>Name:</strong> {Common.replaceNullWithString(duplicatePhysician.lastName) + " " + Common.replaceNullWithString(duplicatePhysician.firstName)}<br />
                                <strong>NPI:</strong> {Common.replaceNullWithString(duplicatePhysician.npi) || 'N/A'}
                            </p>
                            <p className="text-warning mt-2 mb-0">
                                <small><strong>Note:</strong> All records referencing this physician will be updated to reference the replacement physician instead.</small>
                            </p>
                        </div>
                    )}
                    <div className="mb-3">
                        <h6>Select Replacement Physician:</h6>
                        <div className="mb-2">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Filter by Name or NPI..."
                                value={replacementFilter}
                                onChange={(e) => setReplacementFilter(e.target.value)}
                            />
                        </div>
                        {GetReplacementPhysicians().length === 0 && replacementFilter && (
                            <div className="alert alert-info mb-2" role="alert">
                                No physicians found matching your filter.
                            </div>
                        )}
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-sm table-bordered">
                                <thead>
                                    <tr>
                                        <th width="50px">Select</th>
                                        <th>Name</th>
                                        <th>Pro Designations</th>
                                        <th>NPI</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {GetReplacementPhysicians().map((physician) => (
                                        <tr key={physician.physicianId}>
                                            <td>
                                                <input
                                                    type="radio"
                                                    name="replacementPhysician"
                                                    value={physician.physicianId}
                                                    checked={selectedReplacementPhysician?.physicianId === physician.physicianId}
                                                    onChange={() => setSelectedReplacementPhysician(physician)}
                                                />
                                            </td>
                                            <td>{Common.replaceNullWithString(physician.lastName) + " " + Common.replaceNullWithString(physician.firstName)}</td>
                                            <td>{Common.replaceNullWithString(physician.title) ? physician.title : "N/A"}</td>
                                            <td>{Common.replaceNullWithString(physician.npi) || 'N/A'}</td>
                                            <td>{Common.replaceNullWithString(physician.address?.email) || 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={HandleCloseDuplicateModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" size="sm" onClick={HandleConfirmDuplicate}>
                        Confirm Duplicate
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

}

export default Physician;

/*eslint-disable */